<div class="apikey-item">
  <span class="apikey-item__text">{{getObscuredText()}}</span>
  <button class="icon-btn apikey-item__icon-btn apikey-item__toggle-btn" name="toggle-apikey-button" (click)="handleToggle()" [matTooltip]="matTooltipText" matTooltipPosition="above">
    <i class="fa fa-eye" [class.fa-eye-slash]="!isHidden"></i>
  </button>
  <rn-copied-message class="apikey-item__copy-msg" [iconBtn]="true" [inputData]="text"></rn-copied-message>
  @if (canDelete) {
    <button class="icon-btn apikey-item__icon-btn apikey-item__delete-btn" name="delete-apikey-button" (click)="handleDelete()" matTooltip="Delete" matTooltipPosition="above">
      <i class="fa fa-trash"></i>
    </button>
  }
</div>
